<template>
    <div class="mt-1">
        <v-toolbar flat color="white">
            <v-tabs v-model="tab">
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab>Calendar</v-tab>
                <v-tab>Tables</v-tab>
            </v-tabs>
        </v-toolbar>
        <div v-if="tab==0">
            <TicketCalendar />
        </div>
        <div v-if="tab==1">
            <Tickets />
        </div>
    </div>
</template>

<script>
import Api from "@/services/Api.js";
import dateformat from "dateformat";
import TicketCalendar from '../components/TicketCalendar.vue'
import Tickets from '../components/Tickets.vue'


export default {
    components: {
        TicketCalendar,
        Tickets
    },
    data(){
        return {
            tab: 1
        }
    }
}
</script>